import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubHeaderComponent } from '../../../shared/components/sub-header/sub-header.component';
import { UsecaseCard, UsecaseCardData } from '../usecase-card/usecase-card';
import { FooterComponent } from '../../../shared/components/footer/footer.component';

@Component({
  selector: 'app-usecase-home',
  standalone: true,
  imports: [CommonModule, SubHeaderComponent, UsecaseCard, FooterComponent],
  templateUrl: './usecase-home.html',
  styleUrl: './usecase-home.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsecaseHome {
  readonly subHeaderDescription =
    'Explore healthcare-specific analytics applications built to unlock clinical understanding, streamline research workflows, and generate privacy-preserving insights from trusted healthcare data.';

  readonly usecases: ReadonlyArray<UsecaseCardData> = [
    {
      id: 'graph-visualizer',
      title: 'Ontology-based Graph Visualizer',
      shortDescription:
        'Explore healthcare data through clinically meaningful relationships and not raw tables. Navigate conditions, procedures, and outcomes in an intuitive graph interface with secure, privacy-preserving analytics built in.',
      imageSrc: '/usecases/Ontology-based Graph Visualizer.svg',
      tagIcon: '/icons/shield.svg',
      tagLabel: 'Privacy-preserving analytics',
    },
    {
      id: 'no-code-analytics',
      title: 'No-Code Analytics Platform',
      shortDescription:
        'Empower clinicians and researchers to build analytics workflows using drag-and-drop tools. Generate insights, trends, and cohort analyses — without coding and without exposing raw data.',
      imageSrc: '/usecases/No-Code Analytics Platform.svg',
      tagIcon: '/icons/graph.svg',
      tagLabel: 'Insight workflows',
    },
    {
      id: 'entity-mapper',
      title: 'Agentic Entity Mapper',
      shortDescription:
        'Automatically convert unstructured clinical text, scanned records, and EHR exports into standardized SNOMED-CT codes. Secure, audit-ready, and designed for minimal human intervention.',
      imageSrc: '/usecases/Agentic Entity Mapper.svg',
      tagIcon: '/icons/file-teal.svg',
      tagLabel: 'Standardized clinical coding',
    },
    {
      id: 'rag-qa',
      title: 'RAG-Based Q&A System',
      shortDescription:
        'Ask healthcare data questions in natural language and receive trusted, aggregated answers. Ontology-aware, privacy-governed, and built for clinical research and policy insight.',
      imageSrc: '/usecases/RAG-Based Q&A System.svg',
      tagIcon: '/icons/bot.svg',
      tagLabel: 'Trusted aggregated responses',
    },
  ];
}
